<template>
    <div class="contract-list">
        <ob1-popin-modal2 :id="id" :aria-labelledby="ariaLabelId" :show-close-button="false">
            <div ref="contractListPageRef" class="contract-list-page">
                <div class="container-fluid list-contracts">
                    <div class="row pb-1">
                        <div class="col-12 pt-2">
                            <h2 class="mb-0" v-html="routeCustomerTitle" />
                            <h3 class="pt-3 mb-0" v-html="contractsPageData.label" />
                        </div>
                    </div>

                    <!-- Loop through contracts array -->
                    <ul class="items-list row">
                        <div v-for="(contract, index) in contracts" :key="contract.id" class="col-12">
                            <!-- Offre incompatible -->
                            <div v-if="!contract.enabled" class="row">
                                <div class="col-12">
                                    <div class="items-list-item disabled d-block">
                                        <!-- Include contract-item component -->
                                        <contract-item :contract="contract" />
                                    </div>
                                </div>
                                <span class="col-12 ps-4 pt-1 pb-2 text-gray3 small" style="max-width: 28.125rem;">
                                    Cette offre n'est pas compatible
                                </span>
                            </div>

                            <!-- Offre compatible -->
                            <div v-if="contract.enabled">
                                <div v-if="contract.rerouting == null" class="row">
                                    <div class="col-12 pb-2">
                                        <a
                                            class="items-list-item d-block"
                                            :class="[contract.selected && contract.enabled ? 'highlight' : '', contract.enabled ? 'changeContract' : 'disabled']"
                                            :aria-disabled="!contract.enabled"
                                            href="javascript:void(0)"
                                            :data-oevent-category="contractsPageData.contractListTagZone"
                                            :data-oevent-action="contract.offerLabel"
                                            :data-oevent-label="index+1"
                                            @click="getContractUrl(contract)"
                                        >
                                            <!-- Include contract-item component -->
                                            <contract-item :contract="contract" />
                                        </a>
                                    </div>
                                </div>
                                <div v-if="contract.rerouting != null" class="row">
                                    <div class="col-12">
                                        <a
                                            class="items-list-item d-block"
                                            :class="[contract.selected && contract.enabled ? 'highlight' : '', contract.enabled ? 'changeContractRerouting' : '']"
                                            :aria-disabled="!contract.enabled"
                                            href="javascript:void(0)"
                                            :data-oevent-category="contractsPageData.contractListTagZone"
                                            :data-oevent-action="contract.offerLabel"
                                            :data-oevent-label="index+1"
                                            @click="getContractUrl(contract)"
                                        >
                                            <!-- Include contract-item component -->
                                            <contract-item :contract="contract" />
                                        </a>
                                    </div>
                                    <span
                                        class="col-12 ps-4 pt-1 pb-2 text-gray3 small"
                                        style="max-width: 28.125rem;"
                                        v-html="contract.rerouting.messageDescription"
                                    />
                                </div>
                            </div>
                        </div>
                    </ul>

                    <div class="row">
                        <div class="col-12 pt-1 pb-2">
                            <h4 class="h3 mb-0" v-html="contractsPageData.contractNotFoundTitle" />
                            <span class="lead fw-bold pt-1" v-html="contractsPageData.contractNotFoundLabel" />
                            <div class="py-1">
                                <a
                                    class="btn btn-primary mx-auto"
                                    :data-oevent-category="contractsPageData.identifyButtonTms.zone"
                                    :data-oevent-action="contractsPageData.identifyButtonTms.name"
                                    :data-oevent-label="contractsPageData.identifyButtonTms.target"
                                    :href="authenticationUrl"
                                    v-html="contractsPageData.contractNotFoundButton"
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </ob1-popin-modal2>
    </div>
</template>

<script>

import ContractItem from "./ContractItem.vue";

export default {
    name: "ContractSelectorPopin",
    components: { ContractItem },
    props: {
      id: {
        type: String,
        required: true
      },
      contracts: {
        type: Array,
        required: true
      },
      contractPopinDto: {
        type: Object,
        required: true
      }
    },
    data: function () {
        return {
            routeCustomerTitle: this.contractPopinDto.routeCustomerTitle,
            redirectUrl: this.contractPopinDto.redirectUrl,
            changeUrl: this.contractPopinDto.changeUrl,
            authenticationUrl: this.contractPopinDto.authenticationUrl,
            contractsPageData: this.contractPopinDto.contractsPageData,
        }
    },
    computed: {
        ariaLabelId() {
            return this.id + '-title'
        }
    },
    mounted() {
      this.$nextTick(() => {
        this.setupEventListeners();
      });
    },
    methods: {
        setupEventListeners() {
            const contractListPage = this.$refs.contractListPageRef;

            const changeContractHandler = (event) => {
                const items = contractListPage.getElementsByClassName("items-list-item");
                for (let element of items) {
                    element.classList.remove("highlight");
                }
                event.target.closest(".items-list-item").classList.add("highlight");
            };

            const changeContractReroutingHandler = (event) => {
                const items = contractListPage.getElementsByClassName("items-list-item");
                for (let element of items) {
                    element.classList.remove("highlight");
                }
                event.target.closest(".items-list-item").classList.add("highlight");
            };

            contractListPage.querySelectorAll(".changeContract").forEach((element) => {
                element.addEventListener("click", changeContractHandler);
            });

            contractListPage.querySelectorAll(".changeContractRerouting").forEach((element) => {
                element.addEventListener("click", changeContractReroutingHandler);
            });
        },

        getContractUrl(contract) {
            const currentUrl = new URL(contract.rerouting != null ?
                contract.rerouting.url : window.location.href);
            const searchParams = currentUrl.searchParams;
            searchParams.set('idContrat', contract.id);
            window.location.href = currentUrl.toString();
        }
    }
}
</script>
